import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalsoftTrimDirective } from './calsoft-trim.directive';
import { NumberDirective } from './number.directive';
import { NoPrintDirective } from './noprint.directive';
import { TapClickDirective } from './tap-click.directive';



@NgModule({
  declarations: [CalsoftTrimDirective, NumberDirective, NoPrintDirective, TapClickDirective],
  imports: [
    CommonModule
  ],
  exports: [CalsoftTrimDirective, NumberDirective, NoPrintDirective, TapClickDirective]
})
export class DirectiveModule { }
